import { ReactElement, use } from 'react';

import PersonalNumberRangeRowContext from 'features/care-connect-settings/contexts/personal-number-range-row-context';
import PersonalNumberRangeRowUpsert from 'features/care-connect-settings/views/components/personal-number-range-row/personal-number-range-row-upsert';
import PersonalNumberRangeRowViewing from 'features/care-connect-settings/views/components/personal-number-range-row/personal-number-range-row-viewing';

const PersonalNumberRangeRow = (): ReactElement => {
  const { viewingMode } = use(PersonalNumberRangeRowContext);

  switch (viewingMode) {
    case 'creation':
    case 'editing':
      return <PersonalNumberRangeRowUpsert />;
    case 'viewing':
      return <PersonalNumberRangeRowViewing />;
    default:
      return <></>;
  }
};

export default PersonalNumberRangeRow;
